import { useNavigate } from '@tanstack/react-router';
import { CancellationPolicySection } from '../modules/scheduling/index.js';
import { CompanyServices } from '../modules/services/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { ServicesView } from './list-views.js';
import type { ViewSetter } from './view-state.js';

export function CompanyServicesScreen({
  view,
  onView,
}: {
  view: ServicesView;
  onView: ViewSetter<ServicesView>;
}) {
  const { can, timeZone, company } = useCompanyScope();
  const navigate = useNavigate();
  return (
    <GatedCompanyScreen allowed={can('services.read')}>
      <CompanyServices
        capabilities={{
          canCreate: can('services.create'),
          canUpdate: can('services.update'),
          canArchive: can('services.delete'),
          /// Abre a venda com o serviço no carrinho, pelo preço que vale hoje (ADR 0048).
          onSell: can('sales.create')
            ? (service) =>
                void navigate({
                  to: '/companies/$companyKey/sales/new',
                  params: { companyKey: company.key },
                  search: {
                    search: service.displayName,
                    sell: `SERVICE:${service.id}`,
                  },
                })
            : undefined,
        }}
        timeZone={timeZone}
        units={(company.businessUnits ?? []).filter((unit) => unit.kind === 'ESTABLISHMENT')}
        view={view}
        onView={onView}
        serviceExtras={(service) => (
          <CancellationPolicySection
            target={{ kind: 'SERVICE', id: service.id }}
            currency={service.currency}
            level={3}
          />
        )}
      />
    </GatedCompanyScreen>
  );
}
